import { Logo } from "@/components/display";
import { formatDate, formatString } from "@/shared/formats";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { Box, Stack, StackProps, Typography } from "@mui/material";
import { ReactNode } from "react";
import useGetCajaAperturaMetodosMonedas from "../hooks/use-get-caja-apertura-metodos-monedas";
import SharedCajaAperturaTransferenciaMetodoSummaryTable from "./shared-caja-apertura-transferencia-metodo-summary-table";
import SharedCajaAperturaTotalTable from "./shared-caja-apertura-total-table";

export interface PrintCajaAperturaProps extends StackProps {
    cajaApertura: CajaApertura
}

export default function PrintCajaApertura({
    cajaApertura,
    ...props
}: PrintCajaAperturaProps) {
    const [transferenciaMetodos, metodoMonedasMap, monedas] = useGetCajaAperturaMetodosMonedas(cajaApertura);

    return <Stack gap={3} padding={3} {...props}>
        <Stack gap={1}>
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"start"}>
                <Logo />
                <Typography fontSize={"0.75rem"}>
                    <Box component={"span"} fontWeight={"bold"}>Generado en:</Box> {formatDate(new Date(), true)}
                </Typography>
            </Stack>

            <Stack direction={"row"} alignItems={"center"} justifyContent={"center"}>
                <Typography variant="h6">Arqueo de Caja - {cajaApertura.cajaNombre}</Typography>
            </Stack>
        </Stack>
        <Stack gap={1}>
            <AttributeValuePair label="Caja: " value={cajaApertura.cajaNombre} />
            <AttributeValuePair label="Fecha de Apertura: " value={formatDate(cajaApertura.fechaApertura, true)} />
            <AttributeValuePair label="Abierto Por: " value={formatString(cajaApertura.creadoPor)} />
            <AttributeValuePair label="Fecha de Cierre: " value={formatDate(cajaApertura.fechaCierre, true)} />
            <AttributeValuePair label="Cerrado Por: " value={formatString(cajaApertura.modificadoPor)} />
        </Stack>
        {transferenciaMetodos.map(tm => <SharedCajaAperturaTransferenciaMetodoSummaryTable
            key={tm.id}
            cajaApertura={cajaApertura}
            transferenciaMetodo={tm}
            monedas={metodoMonedasMap[tm.id]}
        />)}
        <Stack direction={"row"} alignItems={"start"}>
            <SharedCajaAperturaTotalTable cajaApertura={cajaApertura} monedas={monedas} />
        </Stack>
    </Stack>
}

function AttributeValuePair({
    label,
    value
}: {
    label: ReactNode,
    value: ReactNode
}) {
    return <Stack direction={"row"} gap={2}>
        <Typography variant="subtitle2">{label}</Typography>
        <Typography variant="body2">{!value && value !== 0 ? "---" : value}</Typography>
    </Stack>
}